const error = require('./error');
const success = require('./success');
const { errors } = require('@transfeeradev/api-enums');
const moment = require('@transfeeradev/moment');
const SimpleBarcode = require('./SimpleBarcode');

class DueDate {
  constructor(billet) {
    this._billet = billet;
    this._barcodeData = new SimpleBarcode(this._billet).getData();
  }

  static getLastBusinessDayOfYear(date) {
    let lastDay = moment(date).endOf('year').startOf('day');
    while (!lastDay.isBusinessDay()) {
      lastDay = lastDay.subtract(1, 'day');
    }

    return lastDay;
  }

  static isLastBusinessDayOfYear(date) {
    const lastDay = DueDate.getLastBusinessDayOfYear(date);
    return moment(date).isSame(lastDay, 'day');
  }

  validate() {
    if (this.isOverdue()) {
      return error(errors.ptBr.bil.EXPIRED_DUE_DATE, 'due_date');
    }

    return success;
  }

  isOverdue() {
    if (!this._barcodeData.dueDate) {
      return false;
    }

    const paymentDate = this._billet.payment_date ? moment(this._billet.payment_date) : moment();
    const barcodeDueDate = moment(this._barcodeData.dueDate);
    const dueDate =
      barcodeDueDate.isBusinessDay() && !DueDate.isLastBusinessDayOfYear(barcodeDueDate)
        ? barcodeDueDate
        : barcodeDueDate.nextBusinessDay();

    return paymentDate.isAfter(dueDate, 'day');
  }
}

module.exports = DueDate;
